'use client';

import { c as _c } from "react/compiler-runtime";
import { duracaoNegociacao } from '../../../utils/duracaoNegociacao';
interface MarcosDuracaoBadgeProps {
  dataCriacao: string | null | undefined;
  dataEncerramento: string | null | undefined;
}
export function MarcosDuracaoBadge(t0) {
  const $ = _c(5);
  const {
    dataCriacao,
    dataEncerramento
  } = t0;
  let t1;
  if ($[0] !== dataCriacao || $[1] !== dataEncerramento) {
    t1 = duracaoNegociacao({
      dataCriacao,
      dataEncerramento
    });
    $[0] = dataCriacao;
    $[1] = dataEncerramento;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const rotulo = t1;
  if (!rotulo) {
    return null;
  }
  let t2;
  if ($[3] !== rotulo) {
    t2 = <span className="bg-marco-icone-bg text-brand-600 inline-flex w-fit shrink-0 items-center rounded-full px-2.5 py-1 text-[12px] leading-4 font-normal whitespace-nowrap">{rotulo}</span>;
    $[3] = rotulo;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}